import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderModule } from './components/template/header/header.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuModule } from "./components/template/menu/menu.module";
import { CompartilhadoService } from './services/compartilhado/compartilhado.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { ptBrLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { CompartilhadoUsuarioService } from './services/compartilhado/compartilhado-usuario.service';
import { ToastrModule } from 'ngx-toastr';
import { InterceptorComponent } from './components/interceptor/interceptor.component';
import { HTTPListener } from './services/interceptor/HTTPListener/httplistener.service';
import { HTTPStatus } from './services/interceptor/HTTPStatus/httpstatus.service';
import { HTTPUtils } from './services/interceptor/HTTPUtils/httputils.service';
import { InterceptorHttp } from './security/interceptor-http';
import { CompartilhadoContadorHttpService } from './services/compartilhado/compartilhado-contador-http.service';
import { AuthGuard } from './security/auth.guard';
import { NgxMaskModule } from 'ngx-mask';
import { NgxCurrencyModule } from 'ngx-currency';

defineLocale('pt-br', ptBrLocale);
registerLocaleData(localePt, 'pt-BR');


export const customCurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
  nullable: true
};
@NgModule({
  declarations: [
    AppComponent,
    InterceptorComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HeaderModule,
    MenuModule,
    HttpClientModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig)
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorHttp,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HTTPListener,
      multi: true
    },
    HTTPStatus,
    HTTPListener,
    HTTPUtils,
    CompartilhadoService,
    CompartilhadoContadorHttpService,
    CompartilhadoUsuarioService
  ],
  exports: [InterceptorComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
